import React, { Component } from "react";
import { Query } from "react-apollo";
import classNames from "classnames";
import PropTypes from "prop-types";

import SubscribeStreamCap from "stream/components/SubscribeStreamCap";
import EventStreamCap from "stream/components/EventStreamCap";
import ErrorBoundary from "components/Library/ErrorBoundary";
import { getStreamCapPromoBlockedCookie } from "stream/utils/streamCapCookie";
import STREAM_CAP_QUERY from "./StreamCap.graphql";

import styles from "./StreamCap.css";

class StreamCap extends Component {
  render() {
    const shouldRenderNewsletterSignup = !getStreamCapPromoBlockedCookie();

    return (
      <ErrorBoundary>
        <Query query={STREAM_CAP_QUERY}>
          {({ loading, data }) => {
            const { newsletterSignup, event } = data;

            if (loading) {
              return null;
            }

            return (
              <div
                className={classNames(styles.promoContainer, {
                  [styles.padStreamTitle]: this.props.addPaddingForStreamTitle,
                })}
              >
                {event && <EventStreamCap event={event} />}
                {newsletterSignup && shouldRenderNewsletterSignup && (
                  <SubscribeStreamCap promo={newsletterSignup} />
                )}
              </div>
            );
          }}
        </Query>
      </ErrorBoundary>
    );
  }
}

StreamCap.propTypes = {
  addPaddingForStreamTitle: PropTypes.bool,
};

export default StreamCap;
